import React from 'react';
import collge1 from '../images/Pandit-L.R.-College-Logo-1.png';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot, faPhone, faEnvelope, faClock } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp, faFacebook, faInstagram, faTwitter, faYoutube, faLinkedin } from '@fortawesome/free-brands-svg-icons';

const FooterSection1 = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className='footer'>
      <div className='footer-wave'>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path fill="#ffffff" fillOpacity="0.1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,154.7C960,171,1056,181,1152,170.7C1248,160,1344,128,1392,112L1440,96L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path>
        </svg>
      </div>

      <div className='footer-main-container'>
        {/* College Info Section */}
        <div className='footer-section college-info'>
          <div className='logo-wrapper'>
            <img src={collge1} alt="Pandit L.R. College of Technology" className='footer-logo' />
          </div>
          <div className='college-description'>
            <h3>Pandit L.R. College of Technology</h3>
            <p>Approved by AICTE | Affiliated to HSBTE | Affiliated to Maharishi Dayanand University</p>
            <p>Empowering students with quality technical education since 2008</p>
          </div>
        </div>

        {/* Contact Information */}
        <div className='footer-section contact-info'>
          <h3 className='footer-title'>
            <span>Contact Us</span>
          </h3>
          <ul className='contact-list'>
            <li className='contact-item'>
              <div className='icon-wrapper'>
                <FontAwesomeIcon icon={faLocationDot} />
              </div>
              <div className='contact-details'>
                <strong>Address:</strong>
                <span>Sector-56, Kaboolpur Banger, Ballabgarh, Faridabad - 121004</span>
              </div>
            </li>
            
            <li className='contact-item'>
              <div className='icon-wrapper'>
                <FontAwesomeIcon icon={faPhone} />
              </div>
              <div className='contact-details'>
                <strong>Phone:</strong>
                <a href="tel:+919540028827">+91 9540028827</a>
                <a href="tel:+919540028828">+91 9540028828</a>
              </div>
            </li>
            
            <li className='contact-item'>
              <div className='icon-wrapper'>
                <FontAwesomeIcon icon={faEnvelope} />
              </div>
              <div className='contact-details'>
                <strong>Email:</strong>
                <a href="mailto:ptlrct@gmail.com">ptlrct@gmail.com</a>
                <a href="mailto:admissions@ptlrct.edu.in">admissions@ptlrct.edu.in</a>
              </div>
            </li>
            
            <li className='contact-item'>
              <div className='icon-wrapper'>
                <FontAwesomeIcon icon={faClock} />
              </div>
              <div className='contact-details'>
                <strong>Office Hours:</strong>
                <span>Mon - Sat: 9:00 AM - 5:00 PM</span>
                <span>Sunday: Closed</span>
              </div>
            </li>
          </ul>
        </div>

        {/* Quick Links */}
        <div className='footer-section quick-links'>
          <h3 className='footer-title'>
            <span>Quick Links</span>
          </h3>
          <ul className='links-list'>
            <li><a href="/about">About Us</a></li>
            <li><a href="/admissions">Admissions</a></li>
            <li><a href="/courses">Courses</a></li>
            <li><a href="/placement">Placement</a></li>
            <li><a href="/downloads">Downloads</a></li>
            <li><a href="/contact">Contact Us</a></li>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
            <li><a href="/terms">Terms & Conditions</a></li>
          </ul>
        </div>

        {/* Social Media & WhatsApp */}
        <div className='footer-section social-section'>
          <h3 className='footer-title'>
            <span>Connect With Us</span>
          </h3>
          
          <div className='whatsapp-connect'>
            <a href="https://wa.me/919540028827" className='whatsapp-btn' target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faWhatsapp} />
              <span>Chat on WhatsApp</span>
            </a>
          </div>

          <div className='social-links'>
            <a href="https://www.facebook.com/ptlrct" className='social-link facebook' target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faFacebook} />
              <span className='social-tooltip'>Facebook</span>
            </a>
            <a href="https://x.com/PTLRGROUP" className='social-link twitter' target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faTwitter} />
              <span className='social-tooltip'>Twitter</span>
            </a>
            <a href="https://www.instagram.com/ptlrcollege" className='social-link instagram' target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faInstagram} />
              <span className='social-tooltip'>Instagram</span>
            </a>
            <a href="https://youtube.com/@ptlrgroupofinstitutionsfar7153" className='social-link youtube' target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faYoutube} />
              <span className='social-tooltip'>YouTube</span>
            </a>
            <a href="https://www.linkedin.com/school/ptlrct" className='social-link linkedin' target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faLinkedin} />
              <span className='social-tooltip'>LinkedIn</span>
            </a>
          </div>
        </div>
      </div>

      {/* Map Section */}
      <div className='map-section'>
        <div className='map-container'>
          <iframe
            title="College Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7026.320891105488!2d77.23442613311283!3d28.293463471198386!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cd852dae7e85b%3A0x5817b9b9542ec60e!2sPt.%20L%20R%20Group%20of%20Institutions%20Faridabad%20Delhi%20NCR!5e0!3m2!1sen!2sin!4v1734669109433!5m2!1sen!2sin"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>

      {/* Copyright Section */}
      <div className='copyright-section'>
        <div className='copyright-content'>
          <p>&copy; {currentYear} Pandit L.R. College of Technology. All Rights Reserved.</p>
          <p>Designed & Developed by <a href="https://aswebmatrix.com/">A.S WEB MATRIX TEAM</a></p>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection1;
